export class Game {
  id: number;
  score1: number;
  score2: number;
}
